import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const severityToPriorityMap: Record<string, number> = {
  Critical: 0,
  High: 10,
  Medium: 20,
  Low: 30,
  Informational: 40,
};

const priorityToSeverityMap: Record<number, string> = {
  0: 'Critical',
  10: 'High',
  20: 'Medium',
  30: 'Low',
  40: 'Informational',
};

/**
 * Meta filter: Severity is UI abstraction over priority field
 * "Severity is Critical" → "priority = 0"
 */
export const RiskSeverity: SimpleFilterDefinition = {
  apiField: 'priority',
  uiField: 'Severity',
  inputType: 'dropdown',
  getAvailableValues: () =>
    Promise.resolve(['Critical', 'High', 'Medium', 'Low', 'Informational']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    const rawValue = Number(queryFilter.value);

    return {
      field: 'Severity',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: priorityToSeverityMap[rawValue] ?? String(queryFilter.value),
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return queryFilter.field === 'priority' && queryFilter.operator === '=';
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'priority',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value:
        severityToPriorityMap[String(simpleFilter.value)] ??
        Number(simpleFilter.value),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
